import { z } from 'zod';

const REQUIRED = 'Field is required';

export const RECORDING_FEEDBACK_ROLE_OPTIONS = [
  'Marketing',
  'Product',
  'Sales',
  'Customer Success / Support',
  'Founder / CEO',
  'Engineering',
  '__other_option__',
] as const;

export const RECORDING_FEEDBACK_COMPANY_SIZE_OPTIONS = [
  'Just me / freelancer',
  '2–10',
  '11–50',
  '51–200',
  '201–1,000',
  '1,000+',
] as const;

export const RECORDING_FEEDBACK_USE_CASE_OPTIONS = [
  'Product demo (showing how something works)',
  'Tutorial or how-to for users/customers',
  'Async update for teammates',
  'Sales outreach / personalized video',
  'Bug report or feedback for the team',
  'Social media content',
  '__other_option__',
] as const;

export const RECORDING_FEEDBACK_TOOL_OPTIONS = [
  'Loom',
  'Tella',
  'Descript',
  'Screen Studio',
  'QuickTime / built-in screen recorder',
  "I don't currently use one",
  '__other_option__',
] as const;

export const RECORDING_FEEDBACK_CHAT_OPTIONS = ["Yes, I'm up for it", 'No thanks'] as const;

export const RecordingFeedbackBonusFormSchema = z
  .object({
    chatWillingness: z.enum(RECORDING_FEEDBACK_CHAT_OPTIONS, {
      errorMap: () => ({ message: REQUIRED }),
    }),
    companySize: z.enum(RECORDING_FEEDBACK_COMPANY_SIZE_OPTIONS, {
      errorMap: () => ({ message: REQUIRED }),
    }),
    role: z.enum(RECORDING_FEEDBACK_ROLE_OPTIONS, { errorMap: () => ({ message: REQUIRED }) }),
    roleOther: z.string().default(''),
    tools: z.array(z.enum(RECORDING_FEEDBACK_TOOL_OPTIONS)).min(1, { message: REQUIRED }),
    toolsOther: z.string().default(''),
    useCase: z.enum(RECORDING_FEEDBACK_USE_CASE_OPTIONS, {
      errorMap: () => ({ message: REQUIRED }),
    }),
    useCaseOther: z.string().default(''),
    website: z.string().default(''),
  })
  .superRefine((values, ctx) => {
    if (values.role === '__other_option__' && !values.roleOther.trim()) {
      ctx.addIssue({ code: 'custom', message: REQUIRED, path: ['roleOther'] });
    }
    if (values.useCase === '__other_option__' && !values.useCaseOther.trim()) {
      ctx.addIssue({ code: 'custom', message: REQUIRED, path: ['useCaseOther'] });
    }
    if (values.tools.includes('__other_option__') && !values.toolsOther.trim()) {
      ctx.addIssue({ code: 'custom', message: REQUIRED, path: ['toolsOther'] });
    }
  });

export type RecordingFeedbackBonusForm = z.infer<typeof RecordingFeedbackBonusFormSchema>;
